// This file is auto-generated.
// Please do not edit.
var colors = {
  AssistColorYellow: {
    light: {
      rgba: 'rgba(250, 206, 21, 1)',
      hexa: '#FACE15FF',
      hex: '#FACE15',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(250, 206, 21, 1)',
      hexa: '#FACE15FF',
      hex: '#FACE15',
      alpha: 1
    }
  },
  BGBrand: {
    light: {
      rgba: 'rgba(254, 44, 85, 0.06)',
      hexa: '#FE2C550F',
      hex: '#FE2C55',
      alpha: 0.06
    },
    dark: {
      rgba: 'rgba(254, 44, 85, 0.34)',
      hexa: '#FE2C5557',
      hex: '#FE2C55',
      alpha: 0.34
    }
  },
  BGCreation: {
    light: {
      rgba: 'rgba(18, 18, 18, 1)',
      hexa: '#121212FF',
      hex: '#121212',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(18, 18, 18, 1)',
      hexa: '#121212FF',
      hex: '#121212',
      alpha: 1
    }
  },
  BGCreation2: {
    light: {
      rgba: 'rgba(27, 27, 27, 1)',
      hexa: '#1B1B1BFF',
      hex: '#1B1B1B',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(27, 27, 27, 1)',
      hexa: '#1B1B1BFF',
      hex: '#1B1B1B',
      alpha: 1
    }
  },
  BGInput: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.06)',
      hexa: '#1618230F',
      hex: '#161823',
      alpha: 0.06
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    }
  },
  BGInput2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.06)',
      hexa: '#1618230F',
      hex: '#161823',
      alpha: 0.06
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.08)',
      hexa: '#FFFFFF14',
      hex: '#FFFFFF',
      alpha: 0.08
    }
  },
  BGInverse3: {
    light: {
      rgba: 'rgba(37, 37, 37, 0.6)',
      hexa: '#25252599',
      hex: '#252525',
      alpha: 0.6
    },
    dark: {
      rgba: 'rgba(37, 37, 37, 0.6)',
      hexa: '#25252599',
      hex: '#252525',
      alpha: 0.6
    }
  },
  BGPlaceholderDefault: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.06)',
      hexa: '#1618230F',
      hex: '#161823',
      alpha: 0.06
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.08)',
      hexa: '#FFFFFF14',
      hex: '#FFFFFF',
      alpha: 0.08
    }
  },
  BGPlaceholderOpaque: {
    light: {
      rgba: 'rgba(241, 241, 241, 1)',
      hexa: '#F1F1F1FF',
      hex: '#F1F1F1',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(37, 37, 37, 1)',
      hexa: '#252525FF',
      hex: '#252525',
      alpha: 1
    }
  },
  BGPrimary: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(18, 18, 18, 1)',
      hexa: '#121212FF',
      hex: '#121212',
      alpha: 1
    }
  },
  BGPrimary2: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.04)',
      hexa: '#FFFFFF0A',
      hex: '#FFFFFF',
      alpha: 0.04
    }
  },
  BGQuaternary: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(56, 56, 56, 1)',
      hexa: '#383838FF',
      hex: '#383838',
      alpha: 1
    }
  },
  BGQuinary: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(75, 75, 75, 1)',
      hexa: '#4B4B4BFF',
      hex: '#4B4B4B',
      alpha: 1
    }
  },
  BGReverse: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(18, 18, 18, 1)',
      hexa: '#121212FF',
      hex: '#121212',
      alpha: 1
    }
  },
  BGReverse2: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.9)',
      hexa: '#FFFFFFE6',
      hex: '#FFFFFF',
      alpha: 0.9
    },
    dark: {
      rgba: 'rgba(18, 18, 18, 0.9)',
      hexa: '#121212E6',
      hex: '#121212',
      alpha: 0.9
    }
  },
  BGSecondary: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(37, 37, 37, 1)',
      hexa: '#252525FF',
      hex: '#252525',
      alpha: 1
    }
  },
  BGSecondary2: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.08)',
      hexa: '#FFFFFF14',
      hex: '#FFFFFF',
      alpha: 0.08
    }
  },
  BGTertiary: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(46, 46, 46, 1)',
      hexa: '#2E2E2EFF',
      hex: '#2E2E2E',
      alpha: 1
    }
  },
  BGTertiary2: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    }
  },
  BGView: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.03)',
      hexa: '#16182308',
      hex: '#161823',
      alpha: 0.03
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.04)',
      hexa: '#FFFFFF0A',
      hex: '#FFFFFF',
      alpha: 0.04
    }
  },
  BGView2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.03)',
      hexa: '#16182308',
      hex: '#161823',
      alpha: 0.03
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0)',
      hexa: '#FFFFFF00',
      hex: '#FFFFFF',
      alpha: 0
    }
  },
  ConstBGBrand: {
    light: {
      rgba: 'rgba(254, 44, 85, 0.5)',
      hexa: '#FE2C5580',
      hex: '#FE2C55',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(254, 44, 85, 0.5)',
      hexa: '#FE2C5580',
      hex: '#FE2C55',
      alpha: 0.5
    }
  },
  ConstBGContainer: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    }
  },
  ConstBGContainer2: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.08)',
      hexa: '#FFFFFF14',
      hex: '#FFFFFF',
      alpha: 0.08
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.08)',
      hexa: '#FFFFFF14',
      hex: '#FFFFFF',
      alpha: 0.08
    }
  },
  ConstBGContainer3: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.04)',
      hexa: '#FFFFFF0A',
      hex: '#FFFFFF',
      alpha: 0.04
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.04)',
      hexa: '#FFFFFF0A',
      hex: '#FFFFFF',
      alpha: 0.04
    }
  },
  ConstBGInverse: {
    light: {
      rgba: 'rgba(0, 0, 0, 1)',
      hexa: '#000000FF',
      hex: '#000000',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 1)',
      hexa: '#000000FF',
      hex: '#000000',
      alpha: 1
    }
  },
  ConstBGInverse1: {
    light: {
      rgba: 'rgba(56, 56, 56, 0.95)',
      hexa: '#383838F2',
      hex: '#383838',
      alpha: 0.95
    },
    dark: {
      rgba: 'rgba(56, 56, 56, 0.95)',
      hexa: '#383838F2',
      hex: '#383838',
      alpha: 0.95
    }
  },
  ConstBGInverse2: {
    light: {
      rgba: 'rgba(0, 0, 0, 0.6)',
      hexa: '#00000099',
      hex: '#000000',
      alpha: 0.6
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.6)',
      hexa: '#00000099',
      hex: '#000000',
      alpha: 0.6
    }
  },
  ConstBGInverse3: {
    light: {
      rgba: 'rgba(37, 37, 37, 0.6)',
      hexa: '#25252599',
      hex: '#252525',
      alpha: 0.6
    },
    dark: {
      rgba: 'rgba(37, 37, 37, 0.6)',
      hexa: '#25252599',
      hex: '#252525',
      alpha: 0.6
    }
  },
  ConstBGInverse4: {
    light: {
      rgba: 'rgba(84, 84, 84, 0.5)',
      hexa: '#54545480',
      hex: '#545454',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(84, 84, 84, 0.5)',
      hexa: '#54545480',
      hex: '#545454',
      alpha: 0.5
    }
  },
  ConstBGInverseOpaque: {
    light: {
      rgba: 'rgba(46, 46, 46, 1)',
      hexa: '#2E2E2EFF',
      hex: '#2E2E2E',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(46, 46, 46, 1)',
      hexa: '#2E2E2EFF',
      hex: '#2E2E2E',
      alpha: 1
    }
  },
  ConstBGMat: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.2)',
      hexa: '#FFFFFF33',
      hex: '#FFFFFF',
      alpha: 0.2
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.2)',
      hexa: '#FFFFFF33',
      hex: '#FFFFFF',
      alpha: 0.2
    }
  },
  ConstBGPlaceholderOpaque: {
    light: {
      rgba: 'rgba(241, 241, 241, 1)',
      hexa: '#F1F1F1FF',
      hex: '#F1F1F1',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(241, 241, 241, 1)',
      hexa: '#F1F1F1FF',
      hex: '#F1F1F1',
      alpha: 1
    }
  },
  ConstBGSecondary: {
    light: {
      rgba: 'rgba(32, 213, 236, 0.05)',
      hexa: '#20D5EC0D',
      hex: '#20D5EC',
      alpha: 0.05
    },
    dark: {
      rgba: 'rgba(32, 213, 236, 0.05)',
      hexa: '#20D5EC0D',
      hex: '#20D5EC',
      alpha: 0.05
    }
  },
  ConstLineInverse: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.2)',
      hexa: '#FFFFFF33',
      hex: '#FFFFFF',
      alpha: 0.2
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.2)',
      hexa: '#FFFFFF33',
      hex: '#FFFFFF',
      alpha: 0.2
    }
  },
  ConstLineInverse2: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    }
  },
  ConstTextInverse: {
    light: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 1)',
      hexa: '#FFFFFFFF',
      hex: '#FFFFFF',
      alpha: 1
    }
  },
  ConstTextInverse2: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.9)',
      hexa: '#FFFFFFE6',
      hex: '#FFFFFF',
      alpha: 0.9
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.9)',
      hexa: '#FFFFFFE6',
      hex: '#FFFFFF',
      alpha: 0.9
    }
  },
  ConstTextInverse3: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.75)',
      hexa: '#FFFFFFC0',
      hex: '#FFFFFF',
      alpha: 0.75
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.75)',
      hexa: '#FFFFFFC0',
      hex: '#FFFFFF',
      alpha: 0.75
    }
  },
  ConstTextInverse4: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.5)',
      hexa: '#FFFFFF80',
      hex: '#FFFFFF',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.5)',
      hexa: '#FFFFFF80',
      hex: '#FFFFFF',
      alpha: 0.5
    }
  },
  ConstTextInverse5: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.34)',
      hexa: '#FFFFFF57',
      hex: '#FFFFFF',
      alpha: 0.34
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.34)',
      hexa: '#FFFFFF57',
      hex: '#FFFFFF',
      alpha: 0.34
    }
  },
  ConstTextPrimary: {
    light: {
      rgba: 'rgba(22, 24, 35, 1)',
      hexa: '#161823FF',
      hex: '#161823',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(22, 24, 35, 1)',
      hexa: '#161823FF',
      hex: '#161823',
      alpha: 1
    }
  },
  LineDarker: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.03)',
      hexa: '#16182308',
      hex: '#161823',
      alpha: 0.03
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.35)',
      hexa: '#00000059',
      hex: '#000000',
      alpha: 0.35
    }
  },
  LineInput: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.5)',
      hexa: '#16182380',
      hex: '#161823',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.5)',
      hexa: '#FFFFFF80',
      hex: '#FFFFFF',
      alpha: 0.5
    }
  },
  LineInverse: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.2)',
      hexa: '#16182333',
      hex: '#161823',
      alpha: 0.2
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0)',
      hexa: '#FFFFFF00',
      hex: '#FFFFFF',
      alpha: 0
    }
  },
  LinePrimary: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.2)',
      hexa: '#16182333',
      hex: '#161823',
      alpha: 0.2
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0)',
      hexa: '#FFFFFF00',
      hex: '#FFFFFF',
      alpha: 0
    }
  },
  LinePrimary2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.2)',
      hexa: '#16182333',
      hex: '#161823',
      alpha: 0.2
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.2)',
      hexa: '#FFFFFF33',
      hex: '#FFFFFF',
      alpha: 0.2
    }
  },
  LineReverse2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.12)',
      hexa: '#1618231E',
      hex: '#161823',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    }
  },
  LineReverse3: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.12)',
      hexa: '#1618231E',
      hex: '#161823',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0)',
      hexa: '#FFFFFF00',
      hex: '#FFFFFF',
      alpha: 0
    }
  },
  LineSecondary: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.12)',
      hexa: '#1618231E',
      hex: '#161823',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1E',
      hex: '#FFFFFF',
      alpha: 0.12
    }
  },
  LineSecondary2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.12)',
      hexa: '#1618231E',
      hex: '#161823',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0)',
      hexa: '#FFFFFF00',
      hex: '#FFFFFF',
      alpha: 0
    }
  },
  LineSecondary3: {
    light: {
      rgba: 'rgba(255, 255, 255, 0.12)',
      hexa: '#FFFFFF1F',
      hex: '#FFFFFF',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.5)',
      hexa: '#FFFFFF80',
      hex: '#FFFFFF',
      alpha: 0.5
    }
  },
  Link: {
    light: {
      rgba: 'rgba(254, 44, 85, 1)',
      hexa: '#FE2C55FF',
      hex: '#FE2C55',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 59, 92, 1)',
      hexa: '#FF3B5CFF',
      hex: '#FF3B5C',
      alpha: 1
    }
  },
  Link2: {
    light: {
      rgba: 'rgba(254, 44, 85, 1)',
      hexa: '#FE2C55FF',
      hex: '#FE2C55',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 59, 92, 1)',
      hexa: '#FF3B5CFF',
      hex: '#FF3B5C',
      alpha: 1
    }
  },
  Link3: {
    light: {
      rgba: 'rgba(254, 44, 85, 1)',
      hexa: '#FE2C55FF',
      hex: '#FE2C55',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 59, 92, 1)',
      hexa: '#FF3B5CFF',
      hex: '#FF3B5C',
      alpha: 1
    }
  },
  LiveColorEnd: {
    light: {
      rgba: 'rgba(237, 52, 149, 1)',
      hexa: '#ED3495FF',
      hex: '#ED3495',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(237, 52, 149, 1)',
      hexa: '#ED3495FF',
      hex: '#ED3495',
      alpha: 1
    }
  },
  LiveColorStart: {
    light: {
      rgba: 'rgba(255, 23, 100, 1)',
      hexa: '#FF1764FF',
      hex: '#FF1764',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 23, 100, 1)',
      hexa: '#FF1764FF',
      hex: '#FF1764',
      alpha: 1
    }
  },
  Negative: {
    light: {
      rgba: 'rgba(255, 76, 58, 1)',
      hexa: '#FF4C3AFF',
      hex: '#FF4C3A',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 76, 58, 1)',
      hexa: '#FF4C3AFF',
      hex: '#FF4C3A',
      alpha: 1
    }
  },
  Positive: {
    light: {
      rgba: 'rgba(11, 224, 155, 1)',
      hexa: '#0BE09BFF',
      hex: '#0BE09B',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(11, 224, 155, 1)',
      hexa: '#0BE09BFF',
      hex: '#0BE09B',
      alpha: 1
    }
  },
  Positive2: {
    light: {
      rgba: 'rgba(79, 171, 126, 1)',
      hexa: '#4FAB7EFF',
      hex: '#4FAB7E',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(79, 171, 126, 1)',
      hexa: '#4FAB7EFF',
      hex: '#4FAB7E',
      alpha: 1
    }
  },
  Primary: {
    light: {
      rgba: 'rgba(254, 44, 85, 1)',
      hexa: '#FE2C55FF',
      hex: '#FE2C55',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 59, 92, 1)',
      hexa: '#FF3B5CFF',
      hex: '#FF3B5C',
      alpha: 1
    }
  },
  Primary2: {
    light: {
      rgba: 'rgba(22, 24, 35, 1)',
      hexa: '#161823FF',
      hex: '#161823',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.9)',
      hexa: '#FFFFFFE6',
      hex: '#FFFFFF',
      alpha: 0.9
    }
  },
  SDPrimary: {
    light: {
      rgba: 'rgba(0, 0, 0, 0.8)',
      hexa: '#000000CC',
      hex: '#000000',
      alpha: 0.8
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.8)',
      hexa: '#000000CC',
      hex: '#000000',
      alpha: 0.8
    }
  },
  SDSecondary: {
    light: {
      rgba: 'rgba(0, 0, 0, 0.5)',
      hexa: '#00000080',
      hex: '#000000',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.68)',
      hexa: '#000000AD',
      hex: '#000000',
      alpha: 0.68
    }
  },
  SDTertiary: {
    light: {
      rgba: 'rgba(0, 0, 0, 0.2)',
      hexa: '#00000033',
      hex: '#000000',
      alpha: 0.2
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.5)',
      hexa: '#00000080',
      hex: '#000000',
      alpha: 0.5
    }
  },
  Secondary: {
    light: {
      rgba: 'rgba(32, 213, 236, 1)',
      hexa: '#20D5ECFF',
      hex: '#20D5EC',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(32, 213, 236, 1)',
      hexa: '#20D5ECFF',
      hex: '#20D5EC',
      alpha: 1
    }
  },
  Secondary2: {
    light: {
      rgba: 'rgba(16, 162, 197, 1)',
      hexa: '#10A2C5FF',
      hex: '#10A2C5',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(16, 162, 197, 1)',
      hexa: '#10A2C5FF',
      hex: '#10A2C5',
      alpha: 1
    }
  },
  ShadowPrimary: {
    light: {
      rgba: 'rgba(0, 0, 0, 0.12)',
      hexa: '#0000001E',
      hex: '#000000',
      alpha: 0.12
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.12)',
      hexa: '#0000001E',
      hex: '#000000',
      alpha: 0.12
    }
  },
  ShadowSecondary: {
    light: {
      rgba: 'rgba(0, 0, 0, 0.06)',
      hexa: '#0000000F',
      hex: '#000000',
      alpha: 0.06
    },
    dark: {
      rgba: 'rgba(0, 0, 0, 0.06)',
      hexa: '#0000000F',
      hex: '#000000',
      alpha: 0.06
    }
  },
  TagBrownBG: {
    light: {
      rgba: 'rgba(245, 240, 240, 1)',
      hexa: '#F5F0F0FF',
      hex: '#F5F0F0',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(128, 89, 89, 1)',
      hexa: '#805959FF',
      hex: '#805959',
      alpha: 1
    }
  },
  TagBrownText: {
    light: {
      rgba: 'rgba(128, 89, 89, 1)',
      hexa: '#805959FF',
      hex: '#805959',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 179, 179, 1)',
      hexa: '#FFB3B3FF',
      hex: '#FFB3B3',
      alpha: 1
    }
  },
  TagGreenBG: {
    light: {
      rgba: 'rgba(239, 245, 242, 1)',
      hexa: '#EFF5F2FF',
      hex: '#EFF5F2',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(89, 128, 102, 1)',
      hexa: '#598066FF',
      hex: '#598066',
      alpha: 1
    }
  },
  TagGreenText: {
    light: {
      rgba: 'rgba(89, 128, 108, 1)',
      hexa: '#59806CFF',
      hex: '#59806C',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(178, 255, 217, 1)',
      hexa: '#B2FFD9FF',
      hex: '#B2FFD9',
      alpha: 1
    }
  },
  TagPurpleBG: {
    light: {
      rgba: 'rgba(246, 240, 245, 1)',
      hexa: '#F6F0F5FF',
      hex: '#F6F0F5',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(128, 89, 108, 1)',
      hexa: '#80596CFF',
      hex: '#80596C',
      alpha: 1
    }
  },
  TagPurpleText: {
    light: {
      rgba: 'rgba(128, 89, 121, 1)',
      hexa: '#805979FF',
      hex: '#805979',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 178, 217, 1)',
      hexa: '#FFB2D9FF',
      hex: '#FFB2D9',
      alpha: 1
    }
  },
  TextPrimary: {
    light: {
      rgba: 'rgba(22, 24, 35, 1)',
      hexa: '#161823FF',
      hex: '#161823',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.9)',
      hexa: '#FFFFFFE6',
      hex: '#FFFFFF',
      alpha: 0.9
    }
  },
  TextQuaternary: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.34)',
      hexa: '#16182357',
      hex: '#161823',
      alpha: 0.34
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.34)',
      hexa: '#FFFFFF57',
      hex: '#FFFFFF',
      alpha: 0.34
    }
  },
  TextReverse: {
    light: {
      rgba: 'rgba(22, 24, 35, 1)',
      hexa: '#161823FF',
      hex: '#161823',
      alpha: 1
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.9)',
      hexa: '#FFFFFFE6',
      hex: '#FFFFFF',
      alpha: 0.9
    }
  },
  TextReverse2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.75)',
      hexa: '#161823C0',
      hex: '#161823',
      alpha: 0.75
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.75)',
      hexa: '#FFFFFFC0',
      hex: '#FFFFFF',
      alpha: 0.75
    }
  },
  TextReverse3: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.5)',
      hexa: '#16182380',
      hex: '#161823',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.5)',
      hexa: '#FFFFFF80',
      hex: '#FFFFFF',
      alpha: 0.5
    }
  },
  TextReverse4: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.34)',
      hexa: '#16182357',
      hex: '#161823',
      alpha: 0.34
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.34)',
      hexa: '#FFFFFF57',
      hex: '#FFFFFF',
      alpha: 0.34
    }
  },
  TextSecondary: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.75)',
      hexa: '#161823C0',
      hex: '#161823',
      alpha: 0.75
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.75)',
      hexa: '#FFFFFFC0',
      hex: '#FFFFFF',
      alpha: 0.75
    }
  },
  TextTertiary: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.5)',
      hexa: '#16182380',
      hex: '#161823',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.5)',
      hexa: '#FFFFFF80',
      hex: '#FFFFFF',
      alpha: 0.5
    }
  },
  TextTertiary2: {
    light: {
      rgba: 'rgba(22, 24, 35, 0.5)',
      hexa: '#16182380',
      hex: '#161823',
      alpha: 0.5
    },
    dark: {
      rgba: 'rgba(255, 255, 255, 0.75)',
      hexa: '#FFFFFFC0',
      hex: '#FFFFFF',
      alpha: 0.75
    }
  },
  ToastDefault: {
    light: {
      rgba: 'rgba(84, 84, 84, 0.92)',
      hexa: '#545454EB',
      hex: '#545454',
      alpha: 0.92
    },
    dark: {
      rgba: 'rgba(84, 84, 84, 0.92)',
      hexa: '#545454EB',
      hex: '#545454',
      alpha: 0.92
    }
  },
  ToastNegative: {
    light: {
      rgba: 'rgba(255, 76, 58, 0.92)',
      hexa: '#FF4C3AEB',
      hex: '#FF4C3A',
      alpha: 0.92
    },
    dark: {
      rgba: 'rgba(255, 76, 58, 0.92)',
      hexa: '#FF4C3AEB',
      hex: '#FF4C3A',
      alpha: 0.92
    }
  }
};

export { colors };
//# sourceMappingURL=colors.js.map
